export default __webpack_public_path__ + "static/media/serradourada.5f94684d.png";